import axios from 'axios';
import { Original, OwnedToken } from 'components/common';
import { legacyApiBaseUrl } from './config';

export const getStatus = async (): Promise<any> => {
  const res = await axios.get(`${legacyApiBaseUrl}/status`);
  return res.data;
};

export const getAllOriginals = async (): Promise<Original[]> => {
  try {
    const ebGenEnigmaRes = await axios.get(`${legacyApiBaseUrl}/originals`);

    return [...ebGenEnigmaRes.data];
  } catch (error) {
    console.error(error);
    return [];
  }
};

// DO NOT remove this unused function. Removing it will break the build workflow. 
export const getOwnedTokens = async (address: string | null): Promise<OwnedToken[]> => {
  return [];
};

export const getOriginalById = async (contractAddress: string, id: string): Promise<Original> => {
  if (!contractAddress || !id) {
    throw new Error('Missing contract address or id');
  }

  const res = await axios.get(`${legacyApiBaseUrl}/originals/${contractAddress}:${id}`);
  return res.data;
};
